/**
 * ToastContext — système global de notifications "toast".
 */
import { createContext, useState, useCallback, useEffect } from "react";
import Toast from "../components/Toast";
import { registerToastHandler } from "../services/api";

export const ToastContext = createContext(null);

let counter = 0;

export function ToastProvider({ children }) {
  const [toasts, setToasts] = useState([]);

  /** Ajoute un toast — retourne un id pour pouvoir le retirer manuellement. */
  const showToast = useCallback((message, options = {}) => {
    const id = ++counter;
    const toast = {
      id,
      message,
      type: options.type || "info",
      duration: options.duration ?? 4000,
    };
    setToasts((prev) => [...prev, toast]);
    if (toast.duration > 0) {
      setTimeout(() => {
        setToasts((prev) => prev.filter((t) => t.id !== id));
      }, toast.duration);
    }
    return id;
  }, []);

  /** Retire un toast par son id. */
  const dismissToast = useCallback((id) => {
    setToasts((prev) => prev.filter((t) => t.id !== id));
  }, []);

  const value = {
    showToast,
    dismissToast,
    success: (msg, opts) => showToast(msg, { ...opts, type: "success" }),
    error: (msg, opts) => showToast(msg, { ...opts, type: "error" }),
    info: (msg, opts) => showToast(msg, { ...opts, type: "info" }),
    warning: (msg, opts) => showToast(msg, { ...opts, type: "warning" }),
  };

  // Connecte les intercepteurs axios à showToast pour les erreurs globales
  useEffect(() => {
    registerToastHandler((message, type = "info") => showToast(message, { type }));
    return () => registerToastHandler(null);
  }, [showToast]);

  return (
    <ToastContext.Provider value={value}>
      {children}
      <div
        style={{
          position: "fixed",
          top: "20px",
          right: "20px",
          zIndex: 9999,
          display: "flex",
          flexDirection: "column",
          gap: "8px",
          maxWidth: "calc(100vw - 40px)",
        }}
      >
        {toasts.map((t) => (
          <Toast key={t.id} {...t} onDismiss={() => dismissToast(t.id)} />
        ))}
      </div>
    </ToastContext.Provider>
  );
}
